const icon = `
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 35 35" style="enable-background:new 0 0 35 35;" xml:space="preserve">
  <style type="text/css">
    .st0{fill:none;stroke:{{strokeColor}};stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}
    .st1{fill:{{strokeColor}}}
    .st2{fill:none;stroke:{{strokeColor}};stroke-miterlimit:10;}
  </style>
  <path class="st0" d="M26.17,27.87H8.74c-2.36,0-4.29-1.93-4.29-4.29V12.16c0-2.36,1.93-4.29,4.29-4.29h17.43
	c2.36,0,4.29,1.93,4.29,4.29v11.43C30.46,25.94,28.53,27.87,26.17,27.87z"/>
  <path class="st0" d="M26.46,27.87h-18c-2.2,0-4-1.8-4-4v0c0-2.2,1.8-4,4-4h18c2.2,0,4,1.8,4,4v0
    C30.46,26.07,28.66,27.87,26.46,27.87z"/>
  <circle class="st1" cx="10.29" cy="24.06" r="1.5"/>
  <circle class="st1" cx="17.64" cy="24.06" r="1.5"/>
  <circle class="st1" cx="24.99" cy="24.06" r="1.5"/>
  <line class="st2" x1="8.61" y1="7.87" x2="8.61" y2="19.87"/>
  <line class="st2" x1="14.57" y1="7.87" x2="14.57" y2="19.87"/>
  <line class="st2" x1="20.53" y1="7.87" x2="20.53" y2="19.87"/>
  <line class="st2" x1="26.49" y1="7.87" x2="26.49" y2="19.87"/>
</svg>
`

export const mcsPath = {
  name: 'mcsPath',
  description: 'a group of various mcs-paths',
  icon,
  templates: []
}
